import { render } from "./Modules.vue?vue&type=template&id=59455b6a&scoped=true&ts=true"
import script from "./Modules.vue?vue&type=script&lang=ts"
export * from "./Modules.vue?vue&type=script&lang=ts"

import "./Modules.vue?vue&type=style&index=0&id=59455b6a&scoped=true&lang=scss"

import exportComponent from "/builds/Moodbuster2.0/server/web-server/repos/patient_portal_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59455b6a"]])

export default __exports__